import type { GetRootCommandFn } from '@wix/cli-command-contract';
import { WIX_CONFIG_FILENAME } from '@wix/cli-core-definitions';
import { fields, variant } from 'variant';
import { importCliApp } from './cli-app.js';
import { importCliAstro } from './cli-astro.js';
import { importCliSite } from './cli-site.js';
import { isWixConfigExists, readWixConfig } from './files/wix.config.js';

const ProgramFlow = variant({
  APP: fields<{ getRootCommand: GetRootCommandFn }>(),
  ASTRO: fields<{ getRootCommand: GetRootCommandFn }>(),
  SITE: fields<{ getRootCommand: GetRootCommandFn }>(),
  UNKNOWN: fields<{ reason: string }>(),
});

export async function identifyProgramFlow(projectFolder: string) {
  const isConfigExist = await isWixConfigExists(projectFolder);

  if (!isConfigExist) {
    return ProgramFlow.UNKNOWN({
      reason: `Project type could not be determined due to a missing configuration file "${WIX_CONFIG_FILENAME}".`,
    });
  }

  const config = await readWixConfig(projectFolder);

  const astro = await importCliAstro(config, projectFolder);
  if (astro) {
    return ProgramFlow.ASTRO({ getRootCommand: astro.getRootCommand });
  }

  const app = await importCliApp(config);
  if (app) {
    return ProgramFlow.APP({ getRootCommand: app.getRootCommand });
  }

  const site = await importCliSite(config);
  if (site) {
    return ProgramFlow.SITE({ getRootCommand: site.getRootCommand });
  }

  return ProgramFlow.UNKNOWN({
    reason:
      'A configuration file was found, but it is either malformed or missing required fields, preventing project type identification.',
  });
}
